export default __webpack_public_path__ + "static/media/ic-success-green.06a75c95.svg";